<template>
  <div v-if="paymentSummary.total > 0" class="payment-company-info">
    <div class="payment-company-info-top">
      <!-- СТРАНА -->
      <div class="payment-company-info-country">
        <span class="payment-info-title-text mb-2">
          {{ $t('common.country') }}
        </span>
        <v-autocomplete
          :value="companyInfo.countryCode"
          :items="$i18n.locale === 'ru' ? countriesListRu : countriesListEn"
          outlined
          dense
          rounded
          solo
          hide-details
          clearable
          :menu-props="{ maxWidth: '243px' }"
          content-class="payment-countries-select"
          @input="handleCountryChange"
        ></v-autocomplete>
      </div>

      <!-- ПОЧТОВЫЙ ИНДЕКС -->
      <div class="payment-company-info-postcode">
        <span class="payment-info-title-text mb-2">
          {{ $t('common.postcode') }}
        </span>
        <input
          v-model="companyInfo.postalCode"
          class="payment-info-input"
          type="text"
        />
      </div>
    </div>

    <div class="company-info-wrapper">
      <div class="company-info-title">
        {{ $t('plans.companyInfoTitle') }}
      </div>
      <div class="company-info-desc">
        {{ $t('plans.companyInfoDesc') }}
      </div>

      <!-- КНОПКА 'ДОБАВИТЬ ИНФОРМАЦИЮ О КОМПАНИИ' -->
      <div
        v-if="!companyInfoSectionOpened"
        class="add-company-info-button"
        @click="companyInfoSectionOpened = true"
      >
        <v-icon
          :size="14"
          color="purple"
          class="mr-2"
        >
          mdi-plus
        </v-icon>
        <span class="text-uppercase add-company-info-button-text">
          {{ $t('plans.addCompanyInfo') }}
        </span>
      </div>

      <div
        v-else
        class="add-company-section"
      >
        <!-- НАЗВАНИЕ КОМПАНИИ -->
        <div class="company-name-wrapper">
          <span class="payment-info-title-text mb-2">
            {{ $t('plans.companyName') }}
          </span>
          <input
            v-model="companyInfo.companyName"
            class="payment-info-input"
            type="text"
          />
        </div>

        <!-- СТРАНА И ПОЧТОВЫЙ ИНДЕКС -->
        <div class="payment-company-info-top mt-4">
          <!-- СТРАНА -->
          <div class="payment-company-info-country">
            <span class="payment-info-title-text mb-2">
              {{ $t('common.country') }}
            </span>
            <v-autocomplete
              :value="companyInfo.countryCode"
              :items="$i18n.locale === 'ru' ? countriesListRu : countriesListEn"
              outlined
              dense
              rounded
              solo
              hide-details
              clearable
              :menu-props="{ maxWidth: '243px' }"
              content-class="payment-countries-select"
              @input="handleCountryChange"
            ></v-autocomplete>
          </div>

          <!-- ПОЧТОВЫЙ ИНДЕКС -->
          <div class="payment-company-info-postcode">
            <span class="payment-info-title-text mb-2">
              {{ $t('common.postcode') }}
            </span>
            <input
              v-model="companyInfo.postalCode"
              class="payment-info-input"
              type="text"
            />
          </div>
        </div>

        <!-- АДРЕС 1 -->
        <div class="company-address-wrapper mt-4">
          <span class="payment-info-title-text mb-2">
            {{ $t('plans.address1') }}
          </span>
          <input
            v-model="companyInfo.address"
            class="payment-info-input"
            type="text"
          />
        </div>

        <!-- АДРЕС 2 -->
        <div class="company-address-wrapper mt-4">
          <span class="payment-info-title-text mb-2">
            {{ $t('plans.address2') }}
          </span>
          <input
            v-model="companyInfo.addressDetails"
            class="payment-info-input"
            type="text"
          />
        </div>

        <!-- ГОРОД, ОБЛАСТЬ/РАЙОН -->
        <div class="company-city-region-wrapper mt-4">
          <!-- ГОРОД -->
          <div class="company-city-wrapper flex-grow-1">
            <span class="payment-info-title-text mb-2">
              {{ $t('common.city') }}
            </span>
            <input
              v-model="companyInfo.city"
              class="payment-info-input"
              type="text"
            />
          </div>

          <!-- ОБЛАСТЬ/РАЙОН -->
          <div class="company-region-wrapper flex-grow-1">
            <span class="payment-info-title-text mb-2">
              {{ $t('common.stateRegion') }}
            </span>
            <input
              v-model="companyInfo.stateRegion"
              class="payment-info-input"
              type="text"
            />
          </div>
        </div>

        <!-- TAX ID, НОМЕР СЧЕТА -->
        <div class="company-taxId-wrapper mt-4 mb-4">
          <!-- TAX ID -->
          <div class="company-taxId flex-grow-1">
            <div class="payment-info-title-text mb-2 align-center">
              VAT ID
              <v-tooltip
                bottom
                max-width="300"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="grey"
                    dark
                    v-bind="attrs"
                    icon
                    x-small
                    class="ml-1"
                    v-on="on"
                  >
                    <v-icon :size="16">
                      far fa-question-circle
                    </v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('common.taxIdTooltip') }}</span>
              </v-tooltip>
            </div>
            <input
              :value="companyInfo.vatId"
              class="payment-info-input"
              type="text"
              @keyup="handleTaxIdChange"
            />
          </div>

          <!-- НОМЕР СЧЕТА -->
          <div
            v-if="$i18n.locale === 'en'"
            class="company-purchase-order-wrapper flex-grow-1"
          >
            <span class="payment-info-title-text mb-2">
              {{ $t('common.purchaseOrder') + ' #' }}
            </span>
            <input
              v-model="companyInfo.purchaseOrder"
              class="payment-info-input"
              type="text"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import { countriesListRu, countriesListEn } from "@/constants/countries";
  import { debounce } from 'lodash'
  import payment from '@/mixins/payment'

  export default {
    name: 'PaymentDialogCompanyInfo',

    mixins: [
      payment
    ],

    props: {
      renew: {
        type: Boolean,
        required: false,
        default: false
      }
    },

    data () {
      return {
        countriesListEn,
        countriesListRu,
        companyInfoSectionOpened: false
      }
    },

    computed: {
      ...mapGetters({
        paymentInfo: 'plans/paymentInfo',
        companyInfo: 'plans/companyInfo',
        paymentSummary: 'plans/paymentSummary',
        countryCode: 'plans/countryCode'
      })
    },

    created () {
      if (this.countryCode) {
        this.handleCountryChange(this.countryCode);
      }
    },

    beforeDestroy () {
      this.$store.commit('plans/RESET_COMPANY_INFO')
      this.companyInfo.country = '';
      this.companyInfo.countryCode = '';
    },

    methods: {
      handleCountryChange (val) {
        const countriesList = this.$i18n.locale === 'ru' ? countriesListRu : countriesListEn
        const country = countriesList.find(item => item.value === val);

        if (country && country.text) {
          this.companyInfo.country = country.text
        }

        this.companyInfo.countryCode = val
      },

      debouncedFunction: debounce(function() {
        this.updatePaymentInfo(this.renew)
      }, 1000),

      handleTaxIdChange(evt) {
        this.companyInfo.vatId = evt.currentTarget.value

        if (this.companyInfo.countryCode) {
          this.debouncedFunction()
        }
      }
    }
  }
</script>

<style>
  .payment-company-info {
    margin-top: 24px;
  }

  .payment-company-info-top .v-input__slot {
    box-shadow: unset!important;
    padding: 0 8px 0 24px!important;
  }

  .payment-info-input {
    height: 40px;
  }

  .payment-company-info-top {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }

  .payment-company-info-postcode {
    flex: 1;
  }

  .payment-company-info-country {
    flex: 1;
  }

  .company-info-wrapper {
    margin-top: 24px;
  }

  .company-info-title {
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    color: #000000;
    margin-bottom: 12px;
  }

  .company-info-desc {
    font-weight: 400;
    font-size: 13px;
    line-height: 135%;
    display: flex;
    align-items: flex-end;
    font-feature-settings: 'tnum' on, 'lnum' on;
    color: #555E71;
  }

  .add-company-info-button {
    width: 229px;
    height: 36px;
    border: 1px solid #B547E9;
    border-radius: 50px;
    background: transparent;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin-top: 16px;
  }

  .add-company-info-button-text {
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #B547E9;
  }

  .company-name-wrapper {
    margin-top: 16px;
  }

  .company-city-region-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  .company-taxId-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
  }

  .payment-countries-select input:focus .v-autocomplete__content {
    max-width: 200px;
  }
</style>